import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class SubscriptionCoordinatorSerializer extends ApplicationSerializer {
  keyForRelationship(key: string, relationship: string, method: string) {
    const k = super.keyForRelationship(key, relationship, method)
    return k === 'user' ? 'teacher' : k
  }
}
